import TomSelect from "tom-select";
import GavSearch from "./Gav-search";
import GavList from "./Gav-list";
import GavDetail from "./Gav-detail";

    document.addEventListener("DOMContentLoaded", function() {
        console.log('GavSearch Loading');

        /**
         * Initialize GAV-Search
         */
        let canInitGavSearch = document.querySelectorAll('.ce-type-frpuniagav_gavsearch .gav-search form.gav-search');
        console.log('canInitForm 1:', canInitGavSearch);
        if (canInitGavSearch.length) {
            canInitGavSearch.forEach((form) => {
                let gavSearch = new GavSearch(form);
                console.log('gavSearch:', gavSearch);
            });
        }

        /**
         * Initialize List Plugin
         */
        let gavListForm = document.querySelectorAll('.ce-type-frpuniagav_gavsearchlist .gav-search form.gavsearch-list');
        if(gavListForm.length) {
            gavListForm.forEach((form) => {
                let gavList = new GavList(form);
                console.log('gavList:', gavList);
            });
        }

        /**
         * Initialize Detail Plugin
         */
        let gavDetail = document.querySelectorAll('.ce-type-frpuniagav_gavsearchdetail .gav-search .gavsearch-detail');
        if(gavDetail.length) {
            gavDetail.forEach((form) => {
                let gavD = new GavDetail(form);
                console.log('gavDetail:', gavD);
            });
        }

    });

    function initializeStep2() {
        let contracts = document.querySelectorAll('.gav-search .contract');
        contracts.forEach(function(c) {
            c.addEventListener('click', function (e) {
                e.preventDefault();

                let contractNumber = e.target.dataset.contractnumber;
                let versionNumber = e.target.dataset.versionNumber; // @todo save globaly
                let editionId = e.target.dataset.editionId; // @todo save globaly
                console.log('User Choos Contract No.', editionId);
                getMinimumSalaryFields(editionId, contractNumber);

            })
        })
    }

    function getMinimumSalaryFields(editionId, contractNumber) {
        let apiUrl = '/fileadmin'; // @todo get this value from a global var
        let endpoint = `{{HOST_UNIAAPI}}/api/minimumsalary/${editionId}/structure?language=de-CH`;
        endpoint = `${apiUrl}/api/minimumsalary/11457/criteria/structure.json?language=de-CH`;
        let url = endpoint;
        let requestHeaders = new Headers({
            "Unia-Api-Key": "!frappant",
            'Content-Type': 'application/json'
        });
        fetch(url, {
            method: 'GET',
            mode: 'cors',
            headers: requestHeaders
        })
            .then(response => response.json())
            .then(json => {
                console.log('json', json);
                showMinimumSalaryFields(json);
            }).catch((e)=>{
            console.log('fetch error', e);
        });
    }

    function showMinimumSalaryFields(data) {
        let formContainer = document.querySelector(".ce-type-list .gav-search");
        let html = '<ul>';
        data.forEach((e) => {
            console.log("e+",e);
            html = html + "<li>"+ e.title +"</li>";
        })
        formContainer.innerHTML = html;
        initializeStep2();
    }

